module.exports = __webpack_public_path__ + "img/vermieter.66311e12.jpg";